import ThirdPartyApps from './third-party-apps-page';

export default function ThirdPartyAppsPage() {
  return <ThirdPartyApps />;
}
